import React, { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDeleteUserMutation } from "store/slices/apis/userApiSlice";

const DeleteUser = (props) => {
    const dispatch = useDispatch();
    const { open, handleClose, userId } = props;
    const [deleteUser, { isLoading }] = useDeleteUserMutation();

    const handleSubmit = async () => {
        try {
            await deleteUser(userId).unwrap();
            openNotification("User deleted successfully!", "success");
            handleClose();
        } catch (error) {
            openNotification("Failed to delete user!", "error");
            //handleClose();
            console.error(error);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };


    return (
        <>
            {/* ---------- Popup Dialog ---------- */}
            <Dialog
                open={open}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: { borderTopLeftRadius: "5px", borderTopRightRadius: "5px", backgroundColor: "#FFFFFF", width: "100%", overflowX: "hidden" },
                }}
                disableEscapeKeyDown
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #ddd",
                        backgroundColor: "#ECECEC",
                        pb: 2,
                        pt: 3,
                        width: "100%",
                    }}
                >
                    <Box>
                        <Typography sx={{ fontWeight: 600, fontSize: "27px", lineHeight: "100%", color: "#140F36", fontFamily: "Outfit, sans-serif" }}>
                            Delete User
                        </Typography>
                        <Typography sx={{
                            pt: 2, fontWeight: 400, fontSize: "14px", lineHeight: "100%", color: "#433F5E", fontFamily: "Outfit, sans-serif",
                        }}>
                            Are you sure you want to delete this user
                        </Typography>
                    </Box>

                </DialogTitle>
                <DialogContent sx={{ width: "100%", p: 4, overflowX: "hidden", boxSizing: "border-box" }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", md: "row" },
                            gap: { xs: 2, md: 1 },
                            width: "100%",
                            boxSizing: "border-box",
                            overflowX: "hidden",
                            mt: 4,
                            justifyContent: "flex-end",
                        }}
                    >
                        <Button onClick={handleClose}
                            sx={{
                                textTransform: "none",
                                color: "#F15744",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                fontFamily: "Outfit, sans-serif",
                            }}>
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            onClick={handleSubmit}
                            variant="contained"
                            sx={{
                                backgroundColor: "#00344C",
                                borderRadius: "25px",
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "100%",
                                fontFamily: "Outfit, sans-serif",
                                color: "#FFFFFF",
                                px: "18px",
                                py: "12px",
                            }}
                        >
                            Delete User
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DeleteUser;